export var LoginStep;
(function (LoginStep) {
    LoginStep["ENTER_EMAIL"] = "enterEmail";
    LoginStep["ENTER_PASSWORD"] = "enterPassword";
    LoginStep["RESET_PASSWORD"] = "resetPassword";
    LoginStep["SIGNUP"] = "signup";
})(LoginStep || (LoginStep = {}));
//# sourceMappingURL=signUp.js.map